"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AVAILABLE_STATUS = void 0;
var USER_AVAILABLE_STATUS;
(function (USER_AVAILABLE_STATUS) {
    USER_AVAILABLE_STATUS["AVAILABLE"] = "AVAILABLE";
    USER_AVAILABLE_STATUS["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(USER_AVAILABLE_STATUS || (exports.USER_AVAILABLE_STATUS = USER_AVAILABLE_STATUS = {}));
